import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { TViewedOfficeScope } from '~/types/ViewedOfficeScope';
import { toViewedOfficeHeaders } from '~/utils/viewedOfficeScope';
import type { IGetInvoicesParams, IInvoicesResponse } from '../types/Invoices';

/**
 * A page of invoices. The endpoint scopes by `x-office` alone (the office named,
 * plus every office under it), so one location sends its own and the
 * organization sends none, which lists the caller's whole tree.
 */
export const getInvoices = async (
  params: IGetInvoicesParams,
  scope: TViewedOfficeScope,
): Promise<IInvoicesResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.get<IInvoicesResponse>('/invoices', {
    headers: { ...headers, ...toViewedOfficeHeaders(scope) },
    params,
  });
  return data;
};
